import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { neutral } from '../../../../styles/mui/colors';
import Link from '../../../Links/Link/Link';

/**
 * @param {object} props
 * @param {Object[]} [props.categories=[]]
 * @param {string} [props.tags='']
 * @param {string} props.publishDate
 */
const StoryblokBlogPostFooterComponent = ({
  categories = [],
  tags: tagsString = '',
  publishDate,
}) => {
  const intl = useIntl();

  const publishDateLabel =
    publishDate &&
    intl.formatMessage(
      { id: 'StoryblokBlogPostHeading.createDate' },
      {
        date: intl.formatDate(new Date(publishDate), {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        }),
      },
    );
  const publishDateElement = publishDate && (
    <Typography sx={{ m: 0, mr: 1 }} variant="body2">
      {publishDateLabel}
    </Typography>
  );

  const categoriesElement = categories && (
    <Box sx={{ display: 'flex', flexDirection: 'row', lineHeight: 1.6 }}>
      <Typography sx={{ m: 0, mr: 1 }} variant="body2">
        <FormattedMessage id="StoryblokBlogPostHeading.category" />
      </Typography>
      {categories.map((category, i) => {
        if (!category?.content?.label) return null;
        return (
          <Box key={`category-${i}`} sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography component={Link} to={`/blog?category=${category.slug}`} variant="body2">
              {category.content.label}
            </Typography>
            {i !== categories.length - 1 ? (
              <Typography sx={{ mx: 1 }} variant="body2">
                •
              </Typography>
            ) : null}
          </Box>
        );
      })}
    </Box>
  );

  const tags = tagsString
    .trim()
    .split(',')
    .map((tag) => tag.trim());
  const tagElement = tags.length > 0 && (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', lineHeight: 1.6 }}>
      <Typography sx={{ m: 0, mr: 1 }} variant="body2">
        {intl.formatMessage({ id: 'BlogPostPage.SectionHeading.tags' })}
      </Typography>
      {tags.map((tag, i) => (
        <Box key={`tag-${i}`} sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography sx={{ m: 0 }} variant="body2">
            {tag}
          </Typography>
          {i !== tags.length - 1 ? (
            <Typography sx={{ mx: 1 }} variant="body2">
              •
            </Typography>
          ) : null}
        </Box>
      ))}
    </Box>
  );

  return (
    <Container maxWidth="xl" sx={{ pb: 4 }}>
      <Grid
        container
        sx={{
          margin: {
            xs: '32px auto 0 auto',
            lg: '60px auto 0 auto',
          },
        }}
      >
        <Grid
          size={{ md: 6, xs: 12 }}
          sx={{ border: `1px solid ${neutral[200]}`, bgcolor: 'white', p: 2, borderRadius: 2 }}
        >
          {publishDateElement}
          {categoriesElement}
          {tagElement}
        </Grid>
      </Grid>
    </Container>
  );
};

StoryblokBlogPostFooterComponent.displayName = 'StoryblokBlogPostFooter';
const StoryblokBlogPostFooter = memo(StoryblokBlogPostFooterComponent);

export default StoryblokBlogPostFooter;
